import { render, staticRenderFns } from "./PublicCardReports.vue?vue&type=template&id=45d63404&scoped=true"
import script from "./PublicCardReports.vue?vue&type=script&lang=js"
export * from "./PublicCardReports.vue?vue&type=script&lang=js"
import style0 from "./PublicCardReports.vue?vue&type=style&index=0&id=45d63404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d63404",
  null
  
)

export default component.exports